__turbopack_context__.v({
  "className": "caveat_5fdde264-module__RImc9q__className",
  "variable": "caveat_5fdde264-module__RImc9q__variable",
});
